"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEnums = toEnums;
function toEnums(data) {
    const enums = [];
    if (data instanceof Map) {
        for (const enumItem of data) {
            enums.push({
                type: "term-enum",
                label: String(enumItem[0]),
                value: String(enumItem[1]),
            });
        }
    }
    else if (Array.isArray(data)) {
        for (const enumItem of data) {
            enums.push({
                type: "term-enum",
                label: String(enumItem),
                value: String(enumItem),
            });
        }
        // This is for legacy meta that doesn't convert metatables into Maps
    }
    else if (typeof data === "object" && data !== null) {
        for (const [label, value] of Object.entries(data)) {
            enums.push({
                type: "term-enum",
                label: String(label),
                value: String(value),
            });
        }
    }
    return enums;
}
//# sourceMappingURL=to-enums.js.map